export enum AuthRouterState {
  LOADING = 'loading',
  UNAUTHORIZED = 'unauthorized',
  AUTHORIZED = 'authorized',
}
